import { useReviewGate } from "@components/QaReview/hooks/useReviewGate";

const GENERATING_REASON = "All sections on the page must finish generating before continuing";

/**
 * Whether the footer's primary button is disabled, and the tooltip saying why.
 * Generating sections win; otherwise the inline "Sign and Complete" path (no QA scanner)
 * is held by the review gate, since that flow has no review controls to satisfy it.
 */
export const useFooterPrimaryButtonState = (isSectionGenerating: boolean, isQaScannerEnabled: boolean) => {
  const { isBlocked, tooltipReason } = useReviewGate();
  if (isSectionGenerating) return { disabled: true, reason: GENERATING_REASON };
  if (!isQaScannerEnabled && isBlocked) return { disabled: true, reason: tooltipReason ?? "" };
  return { disabled: false, reason: "" };
};
